import React from "react";
import FormGroupPlainText from "../formGroupPlainText";
import FormGroupSelectInput from "../formGroupSelectInput";
import Button from "../button";

const CaseForm = (props) => {
    const {} = props;

    if(
        Object.keys(props.Store.selectedApplication).length !== 0
        && props.Store.selectedApplication.constructor === Object
        && (
            props.Store.selectedApplication.policyStatus !== 'Draft'
            || (props.UserRole !== 'Solicitor')
        )
    ) {
        return (
            <form className="form-horizontal">
                <FormGroupPlainText
                    LeftWrapper="col-sm-3"
                    Label="Case Type"
                    InputWrapper="manageSolicitorAccount-data col-sm-6"
                    Text={props.Store.selectedApplication.caseTypeName}
                />
                {props.Store.selectedSubCaseType ?
                    <FormGroupPlainText
                        LeftWrapper="col-sm-3"
                        Label="Sub Case Type"
                        InputWrapper="manageSolicitorAccount-data col-sm-6"
                        Text={props.Store.selectedApplication.subCaseTypeName}
                    />
                    :
                    null
                }
            </form>
        )
    }

    return (
        <form autoComplete={'off'} className="form-horizontal" onSubmit={props.HandleViewSubmit}>
            <FormGroupSelectInput
                Label="Case Type"
                LeftWrapper="col-sm-3"
                Value={props.Store.selectedCaseType}
                Name="selectedCaseType"
                HandleInputChange={props.handleCaseTypeChange}
                Options={props.caseTypeOptions}
                CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                RightWrapper="" Required={true}
                SelectStyle={'form-control formGroupSelectInput-select'}

            />
            {props.Store.selectedCaseType !== '' && props.subCaseTypeOptions.length > 1 && (
                <FormGroupSelectInput
                    Label="Sub Case Type"
                    LeftWrapper="col-sm-3"
                    Name="selectedSubCaseType"
                    Value={props.Store.selectedSubCaseType}
                    Options={props.subCaseTypeOptions}
                    HandleInputChange={props.handleSubCaseTypeChange}
                    CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                    RightWrapper=""
                    SelectStyle={'form-control formGroupSelectInput-select'}

                />
            )}
            {!props.Store.selectedApplication.draft && (
                <div className={'form-group'}>
                    <div className={'col-sm-6 col-sm-offset-3'}>
                        <Button
                            wrapper="btn-wrapper"
                            btnType="submit"
                            btnStyle={'btn btn-primary btn-xs sharp blue'}
                            label="View"
                        />
                    </div>
                </div>
            )}
        </form>
    )
};

export default CaseForm;
